import React, { Component } from "react";

export class Link extends Component {
  getStyle = () => {
    return {
      marginRight: this.props.linkData._ !== "." ? "15px" : "inherit"
    };
  };

  render() {
    const { _, $ } = this.props.linkData;
    const { text, url } = $;
    return (
      <p className="linkData">
        <span style={this.getStyle()}>{_ !== "." ? _ : ""}</span>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      </p>
    );
  }
}

export default Link;
